import React from "react"
// import rd3 from 'react-d3-library'

import { drawRadarChart } from "./charts"
import { inject, observer } from "mobx-react"
// const RD3Component = rd3.Component

export class RadarChart extends React.Component {
  constructor(props) {
    super(props)
    const data = props.chartData
    const options = props.options
    this.state = { chart: null }
  }

  _setChartState(props) {
    const data = props.chartData
    const options = props.options
    const chartData = drawRadarChart(this.node, { data, options })
    //console.log(JSON.stringify(data, null, 2))
    this.setState({ chart: chartData })
  }

  componentDidMount() {
    setTimeout(() => this._setChartState(this.props), 1)
  }

  componentWillReceiveProps(nextProps) {
    this._setChartState(nextProps)
  }

  render() {
    const { options } = this.props
    return (
      <div className="RadarChart">
        <svg
          ref={node => (this.node = node)}
          width={options.w}
          height={options.h}
        />
        {/* <RD3Component data={this.state.chart} /> */}
      </div>
    )
  }
}

// const RadarChart = ({app})=> {
//   const data = app.chartData
//   const chartData = drawRadarChart({data})
//   return <div className="RadarChart">
//     <RD3Component data={chartData} />
//   </div>
// }

export default RadarChart



// WEBPACK FOOTER //
// ./src/components/RadarChart.js